var _rect, _rect2, _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareerTech4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.333374,
    width: 46,
    height: 46,
    rx: 8,
    fill: "#1660E6"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_19121)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(11 11.3334)",
    fill: "#1660E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_19121",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 24,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 11.3334H11V35.3334H35V11.3334Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_19121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8706 29.5914C11.6208 29.9739 11.3396 30.4666 11.1048 30.8371C10.8941 31.1926 11.0073 31.6576 11.3628 31.8759L16.3278 34.9306C16.6908 35.1534 17.1678 35.0364 17.3861 34.6689C17.5856 34.3366 17.8391 33.9069 18.1166 33.4464C20.0853 30.2004 22.0616 30.5949 25.6241 32.3019L30.5809 34.6381C30.9716 34.8256 31.4366 34.6539 31.6084 34.2594L33.9754 28.9119C34.1396 28.5294 33.9716 28.0839 33.5929 27.9121C31.9324 27.1306 30.2801 26.3454 28.6279 25.5526C21.9094 22.3029 16.2221 22.5174 11.8706 29.5914ZM34.1329 17.0753C34.3789 16.6733 34.6601 16.2001 34.8949 15.8251C35.1056 15.4696 34.9886 15.0083 34.6406 14.7938L29.6756 11.7353C29.3126 11.5126 28.8356 11.6296 28.6174 11.9971C28.4224 12.3331 28.1644 12.7591 27.8831 13.2233C25.9181 16.4693 23.9381 16.0711 20.3756 14.3678L15.4383 12.0278C15.0476 11.8403 14.5826 12.0158 14.4108 12.4066L12.0476 17.7541C11.8796 18.1366 12.0513 18.5821 12.4301 18.7538C13.4688 19.2421 15.5313 20.2223 17.3951 21.1133C24.0904 24.3594 29.7859 24.1449 34.1336 17.0746L34.1329 17.0753Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_19121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(11 11.3334)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerTech4);
export default __webpack_public_path__ + "static/media/careerTech4.bad392c1ac15be6d597af9aed48ec4f8.svg";
export { ForwardRef as ReactComponent };